import { useEffect } from 'react';
import { useState } from 'react';

function Clock() {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timerId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => {
            clearInterval(timerId);
        };
    }, []); // Empty array ensures this runs only once

    return (
        <div>
            <h1>Current Time</h1>
            <p>{currentTime.toLocaleTimeString()}</p>
        </div>
    );
}

export default Clock